import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, normalizeClass as _normalizeClass, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-the-page-m08__form c-form-inner" }
const _hoisted_2 = { class: "p-form-group" }
const _hoisted_3 = { class: "p-form-group" }
const _hoisted_4 = { class: "p-form-group" }
const _hoisted_5 = { class: "p-form-group" }
const _hoisted_6 = { class: "p-the-page-m08__code" }
const _hoisted_7 = { class: "p-form-button-group" }
const _hoisted_8 = { class: "p-form-button-group__vertical" }
const _hoisted_9 = { class: "p-form-button-group__vertical" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormLabel = _resolveComponent("FormLabel")!
  const _component_FormUneditableText = _resolveComponent("FormUneditableText")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_ValidationErrorText = _resolveComponent("ValidationErrorText")!
  const _component_FormCode = _resolveComponent("FormCode")!
  const _component_ButtonMain = _resolveComponent("ButtonMain")!
  const _component_TheTemplateM = _resolveComponent("TheTemplateM")!

  return (_openBlock(), _createBlock(_component_TheTemplateM, {
    class: "p-the-page-m08",
    step: _ctx.step,
    "step-options": _ctx.stepOptions
  }, {
    heading: _withCtx(() => _cache[4] || (_cache[4] = [
      _createTextVNode("メールアドレス変更", -1)
    ])),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("form", {
          ref: "form",
          onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_FormLabel, {
              for: "name",
              required: true
            }, {
              default: _withCtx(() => _cache[5] || (_cache[5] = [
                _createTextVNode("メールアドレス", -1)
              ])),
              _: 1,
              __: [5]
            }),
            _createVNode(_component_FormUneditableText, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.currentEmail), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_FormLabel, {
              for: "newEmail",
              required: true
            }, {
              default: _withCtx(() => _cache[6] || (_cache[6] = [
                _createTextVNode("新しいメールアドレス", -1)
              ])),
              _: 1,
              __: [6]
            }),
            _createVNode(_component_InputText, {
              id: "newEmail",
              modelValue: _ctx.newEmail,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newEmail) = $event)),
              type: "text",
              name: "newEmail",
              error: _ctx.errors.newEmail,
              placeholder: "メールアドレス"
            }, null, 8, ["modelValue", "error"]),
            _withDirectives(_createVNode(_component_ValidationErrorText, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.currentAndNewEmailIsSameError), 1)
              ]),
              _: 1
            }, 512), [
              [_vShow, _ctx.currentAndNewEmailIsSame]
            ]),
            _withDirectives(_createVNode(_component_ValidationErrorText, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.errors.newEmail), 1)
              ]),
              _: 1
            }, 512), [
              [_vShow, _ctx.errors.newEmail]
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_FormLabel, {
              for: "newEmailConfirm",
              required: true
            }, {
              default: _withCtx(() => _cache[7] || (_cache[7] = [
                _createTextVNode("新しいメールアドレス（確認用）", -1)
              ])),
              _: 1,
              __: [7]
            }),
            _createVNode(_component_InputText, {
              id: "newEmailConfirm",
              modelValue: _ctx.newEmailConfirm,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newEmailConfirm) = $event)),
              type: "text",
              name: "newEmailConfirm",
              error: _ctx.errors.newEmailConfirm,
              placeholder: "メールアドレス再入力をお願いします。"
            }, null, 8, ["modelValue", "error"]),
            _withDirectives(_createVNode(_component_ValidationErrorText, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.errors.newEmailConfirm), 1)
              ]),
              _: 1
            }, 512), [
              [_vShow, _ctx.errors.newEmailConfirm]
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_FormLabel, {
              for: "code1",
              required: true
            }, {
              default: _withCtx(() => _cache[8] || (_cache[8] = [
                _createTextVNode("認証コード（4桁）", -1)
              ])),
              _: 1,
              __: [8]
            }),
            _cache[9] || (_cache[9] = _createElementVNode("p", { class: "p-the-page-m08__attention" }, [
              _createTextVNode(" メールアドレスの変更には4桁の数字での本人認証が必要となります。以下にお好きな数字 4桁を設定してください。 "),
              _createElementVNode("br"),
              _createTextVNode("※連続した数字4桁（1234等）や、同数字（1111等）はセキュリティ上設定いただけません。 ")
            ], -1)),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_FormCode, {
                code: _ctx.code,
                onSet: _ctx.setCode
              }, null, 8, ["code", "onSet"]),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.code) = $event)),
                type: "hidden",
                name: "code",
                class: _normalizeClass({ 'is-error': _ctx.errors.code })
              }, null, 2), [
                [_vModelText, _ctx.code]
              ]),
              _withDirectives(_createVNode(_component_ValidationErrorText, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.errors.code), 1)
                ]),
                _: 1
              }, 512), [
                [_vShow, _ctx.errors.code]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_ButtonMain, {
                type: "submit",
                disabled: _ctx.isInvalid || _ctx.currentAndNewEmailIsSame
              }, {
                default: _withCtx(() => _cache[10] || (_cache[10] = [
                  _createTextVNode(" 変更 ", -1)
                ])),
                _: 1,
                __: [10]
              }, 8, ["disabled"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_ButtonMain, {
                tag: 'a',
                href: "/my-page/",
                kind: 'cancel'
              }, {
                default: _withCtx(() => _cache[11] || (_cache[11] = [
                  _createTextVNode(" キャンセル ", -1)
                ])),
                _: 1,
                __: [11]
              })
            ])
          ])
        ], 544)
      ])
    ]),
    _: 1
  }, 8, ["step", "step-options"]))
}